'use client';

import React from 'react';

import { LinkToServices } from '@/components/LinkToServices';
import { Media } from '@/components/Media';
import { Svg } from '@ui/svg';
import type { Media as MediaType } from '@/payload-types';

import logo from './assets/logo.svg';

export const HeroAboutPage: React.FC<{
  description: string;
  image: MediaType;
}> = ({ description, image }) => {
  return (
    <section className="v-margin !mt-0" data-name="HeroAboutPage">
      <div className="container">
        <div className="flex gap-6 lg:flex-col">
          <div className="relative w-full max-w-[984px] lg:max-w-none">
            <Media resource={image} imgClassName="corners" priority />

            <h1 className="text-blue md:h2 h1 absolute bottom-0 left-0 z-10 md:leading-9">
              <div className="relative w-fit rounded-tr-[24px] bg-[#FAFAFA] pt-2 pr-9 md:pt-1 md:pr-4">
                О клинике
                <Svg className="absolute bottom-full left-0" id="corner" />
                <Svg className="absolute bottom-0 left-full" id="corner" />
              </div>
              <div className="flex w-fit items-center gap-5 rounded-tr-[24px] bg-[#FAFAFA] py-1 pr-9 pl-[52px] md:w-auto md:pt-0 md:pr-4 md:pb-0 md:pl-5">
                <img className="w-12 flex-none md:w-6" src={logo.src} />
                спасение
                <Svg className="absolute bottom-0 left-full" id="corner" />
              </div>
            </h1>
          </div>

          <div className="w-full max-w-[368px] pt-[29px] md:pt-0 lg:max-w-none">
            <div>{description}</div>
            <LinkToServices className="mt-[50px] md:mt-7" />
          </div>
        </div>
      </div>
    </section>
  );
};
